module.exports = __webpack_public_path__ + "static/img/news7.8247f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news7.png
// module id = tnbu
// module chunks = 52